import {
  PhoneInputControl as KitPhoneInputControl,
  PhoneInputControlProps,
} from 'ui-kit';
import { useCurrentLocationInfo } from '@/components/Google/shared/useCurrentLocationInfo';
import { FC, memo } from 'react';
import { Country } from 'react-phone-number-input';
import { INHERITED_DATA_TEST_ID } from '@/utils/testId.ts';

export const PhoneInputControl: FC<PhoneInputControlProps> = memo((props) => {
  const location = useCurrentLocationInfo();
  return (
    <KitPhoneInputControl
      data-test-id={INHERITED_DATA_TEST_ID}
      {...props}
      defaultCountry={location?.country?.short_name as Country}
      key={location?.country?.short_name}
    />
  );
});
PhoneInputControl.displayName = 'PhoneInputControl';
